import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {
  ServiceTransactionInitState
} from '@/store/service-transaction/service-transaction.types';
import {Toast} from '@/store/toast/toast.types';
import {MemberInitState, MemberTimeInformation} from '@/store/member/member.types';
import {
  EntityTimeTransaction,
  PointTransfer,
  TimeTransactionInitState
} from '@/store/time-transaction/time-transaction.types';
import moment from 'moment';
import {Helper} from '../../../util/helper';

@Component({
  components: {}
})
export default class TransferDetailComponent extends Vue {
  @State('timeTransaction') timeTransactionInitState!: TimeTransactionInitState;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_getTimeTransactionById', {namespace: 'timeTransaction'}) getTimeTransactionById!: (body: string) => Promise<void>;

  public timeTransaction = {
    from: {}
  } as EntityTimeTransaction;
  public createdAtText = '';
  public lib: Helper = new Helper();

  async mounted() {
    try {
      let {id} = this.$route.params;
      await this.getTimeTransactionById(id);
      if (!this.timeTransactionInitState.timeTransactions.length) {
        this.$router.push('/').then();
      }
      this.timeTransaction = this.timeTransactionInitState.timeTransactions[0];
      this.createdAtText = this.lib.formatDateTimeThai(this.timeTransaction.createdAt);
    } catch (e) {
      this.transferHandleError(e)
    }
  }

  transferHandleError(e: any) {
    console.log('DEBUG: e', e);
  }
}


